import { useSortable } from "@dnd-kit/react/sortable";
import { faGripDotsVertical } from "@fortawesome/pro-regular-svg-icons";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon, Flex, TextInput } from "@mantine/core";
import { twMerge } from "tailwind-merge";

import type { ChoiceRuleWithId } from "@/hooks/use-choice-rules-with-duplicates";

interface ChoiceOptionProps {
  index: number;
  isDuplicate: boolean;
  onDeleteClick: (id: string) => void;
  onOptionTextChange: (id: string, text: string) => void;
  option: ChoiceRuleWithId;
}

export const ChoiceOption = ({
  index,
  isDuplicate,
  onDeleteClick,
  onOptionTextChange,
  option,
}: ChoiceOptionProps) => {
  const { handleRef, ref } = useSortable({
    id: option.id,
    index,
  });

  return (
    <Flex
      align="center"
      className={twMerge([
        "rounded",
        "relative",
        "transition-colors",
        "duration-150",
      ])}
      ref={ref}
    >
      <ActionIcon className="cursor-grab" ref={handleRef} variant="transparent">
        <FontAwesomeIcon
          icon={faGripDotsVertical}
          className="text-gray-300"
          size="xl"
        />
      </ActionIcon>
      <TextInput
        value={option.optionText}
        onChange={(e) => onOptionTextChange(option.id, e.target.value)}
        size="sm"
        className="w-full"
        error={isDuplicate ? "This option already exists" : undefined}
        rightSection={
          <ActionIcon
            onClick={() => onDeleteClick(option.id)}
            variant="transparent"
          >
            <FontAwesomeIcon icon={faXmark} size="sm" />
          </ActionIcon>
        }
        required
      />
    </Flex>
  );
};
